<div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch">
  <h2>{{ 'reports.report-files.standard-reports-title' | translate | titlecase }}</h2>
</div>
<div class="mb-5">
  <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="handleDownloadMultipleReportsClick()">
    {{ 'common.download' | translate | titlecase }}
    {{ selectedCount > 0 ? selectedCount : '' }}
    {{ 'common.reports' | translate | titlecase }}
  </button>
</div>

<p-table [showGridlines]="true" [value]="standardReports" [paginator]="false">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>
        <input type="checkbox" (change)="handleSelectAll()" />
      </th>
      <th [pSortableColumn]="'Title'">
        {{ 'reports.report-files.report-name-column-header' | translate | titlecase }}
        <p-sortIcon field="Title"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'ReportFileName'">
        {{ 'reports.report-files.file-name-column-header' | translate | titlecase }}
        <p-sortIcon field="ReportFileName"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'Category'">
        {{ 'reports.report-files.category-column-header' | translate | titlecase }}
        <p-sortIcon field="Category"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'Title'" style="width: 100px"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td>
        <input type="checkbox" [(ngModel)]="item.Selected" (change)="setSelectedCount()" />
      </td>
      <td>
        <div>{{ item.Title }}</div>
      </td>
      <td>
        <div>{{ item.ReportFileName }}</div>
      </td>
      <td>
        <div>{{ item.Category }}</div>
      </td>
      <td>
        <button pButton type="button" class="atlas-btn atlas-btn-primary tall"
          (click)="handleDownloadClick(item.ReportFileName)">
          {{ 'common.download' | translate | titlecase }}
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="searching"></p-progressSpinner>
